import React from "react";
import { Link } from "react-router-dom";
import '../styles/template.css';
import superCareer from '../images/Supercharge-Your-Career.png';
import supercareertwo from "../images/Supercharge-Your-Career-2.png";
import iwd from "../images/IWD.png";
import oneforce from "../images/oneforce-template-img-white-thumbnail.jpg";
import confamjara from "../images/ConfamJaraThumbnail.png";

const Templates = () => {
  return (
    <section id="templates" className="templates p-4">
      <h3 className="my-6 text-center headerText">Our Templates</h3>
      <TemplatesII />
    </section>
  )
}

export default Templates;

export const TemplatesII = () => {
  return (
    <div className="templates-container px-8 flex justify-center items-center flex-wrap sm:w-full md:w-8/12 mx-auto" id="templates-container">
      <div className="template">
        <div className="template-content flex flex-col justify-between">
          <div className="template-content-main">
            <img src={confamjara} alt="ConfamJara" className="absolute top-0 right-0 h-full w-full" draggable="false" />
          </div>
          <Link to='/templates/confamjara' className="template-link text-center">
            Choose Template
          </Link>
        </div>
        <p className="template-title text-center my-4">ConfamJara</p>
      </div>

      <div className="template">
        <div className="template-content flex flex-col justify-between">
          <div className="template-content-main">
            <img src={oneforce} alt="OneForce" className="absolute top-0 right-0 h-full w-full" draggable="false" />
          </div>
          <Link to='/templates/oneforce' className="template-link text-center">
            Choose Template
          </Link>
        </div>
        <p className="template-title text-center my-4">OneForce</p>
      </div>

      <div className="template">
        <div className="template-content flex flex-col justify-between">
          <div className="template-content-main">
            <img src={supercareertwo} alt="Supercharge Your Career II" className="absolute top-0 right-0 h-full w-full" draggable="false" />
          </div>
          <Link to='/templates/super-career-two' className="template-link text-center">
            Choose Template
          </Link>
        </div>
        <p className="template-title text-center my-4">Supercharge Your Career II</p>
      </div>

      <div className="template">
        <div className="template-content flex flex-col justify-between">
          <div className="template-content-main">
            <img src={superCareer} alt="Supercharge Your Career" className="absolute top-0 right-0 h-full w-full" draggable="false" />
          </div>
          <Link to='/templates/super-career' className="template-link text-center">
            Choose Template
          </Link>
        </div>
        <p className="template-title text-center my-4">Supercharge Your Career</p>
      </div>

      <div className="template">
        <div className="template-content flex flex-col justify-between">
          <div className="template-content-main">
            <img src={iwd} alt="International Women's Day" className="absolute top-0 right-0 h-full w-full" draggable="false" />
          </div>
          <Link to='/templates/iwd' className="template-link text-center">
            Choose Template
          </Link>
        </div>
        <p className="template-title text-center my-4">International Women's Day</p>
      </div>
    </div>
  )
}